/**
 * Tech Supply Chain brand palette,
 * derived from the org logo: deep navy primary with a teal accent.
 *
 * Used by the app chrome (BrandMark, AppShell). The Supplier Gateway screens
 * themselves use Meridian components and tokens.
 */
export const brand = {
    navy: '#0a2a52',
    navyDark: '#071d3a',
    teal: '#1f9e8f',
    blue: '#2f7de1',
    pageBg: '#f4f6f9',
    surface: '#ffffff',
    border: '#d5dbe3',
    textMuted: '#5a6b80',
} as const;

export default brand;
